import clsx from 'clsx'
import {hasPermission} from 'common/HelperFunctions'
import useSupportEntry from 'common/components/SupportChoice/useSupportEntry'
import {FC} from 'react'
import {useIntl} from 'react-intl'
import {useLocation} from 'react-router'

type Props = {
  /** `header` — inline text link beside the branch select. `menu` — a Metronic `menu-item` row. */
  variant?: 'header' | 'menu'
}

/**
 * "Need Any Support?" — when the FAQ chatbot is enabled, asks whether to ask Versi or create a
 * support ticket (useSupportEntry); otherwise navigates to the support tickets page. Hidden on
 * the timetable constraints page and for users without `tickets_manager`.
 */
const SupportTicketsLink: FC<Props> = ({variant = 'header'}) => {
  const intl = useIntl()
  const {pathname} = useLocation()
  // The href stays as the fallback for users without `knowledge_base` (or outside the provider).
  const {onSupportClick: onClick, supportChoiceModal} = useSupportEntry()

  if (!hasPermission('tickets_manager')) return null
  if (pathname.includes('/institute/schedule/timetable/constraints')) return null

  const label = intl.formatMessage({id: 'MENU.SUPPORT_TICKETSPAGE'})

  if (variant === 'menu') {
    return (
      <div className='menu-item px-5'>
        <a href='/institute/support-tickets' onClick={onClick} className='menu-link px-5'>
          <span className='menu-icon'>
            <i className='fa fa-headset fs-3' />
          </span>
          <span className='menu-title'>{label}</span>
        </a>
        {supportChoiceModal}
      </div>
    )
  }

  return (
    <div className='app-navbar-item ms-1 ms-md-4'>
      <a
        href='/institute/support-tickets'
        onClick={onClick}
        className={clsx(
          'd-flex align-items-center justify-content-center px-3 py-2 rounded w-auto',
          'text-primary',
          'text-hover-primary'
        )}
        style={{whiteSpace: 'nowrap'}}
      >
        <i className='fa fa-headset me-md-2' style={{fontSize: '15px'}} />
        <span className='d-none d-md-inline'>{label}</span>
      </a>
      {supportChoiceModal}
    </div>
  )
}

export default SupportTicketsLink
